/*
  Расширение Tiptap для возможности перехода по ссылке через Ctrl/Cmd + Клик
*/

import { getAttributes } from '@tiptap/core'
import Link, { type LinkOptions } from '@tiptap/extension-link'
import { Plugin, PluginKey } from '@tiptap/pm/state'

export const ExtendedLink = Link.extend({
  addOptions() {
    if (!this.parent) {
      return {} as LinkOptions
    }
    const parentOptions = this.parent()
    return {
      ...parentOptions,
      openOnClick: false,
    }
  },
  addProseMirrorPlugins() {
    const plugins: Plugin[] = this.parent?.() || []
    const ctrlClickHandler = new Plugin({
      key: new PluginKey('extendedLinkPlugin'),
      props: {
        handleClick(view, pos, event) {
          const attrs = getAttributes(view.state, 'link')
          const link = (event.target as HTMLElement)?.closest('a')

          const keyPressed = event.ctrlKey || event.metaKey

          if (keyPressed && link && attrs.href) {
            const target = attrs.target || '_blank'
            const openedWindow = window.open(attrs.href, target, 'noopener,noreferrer')
            if (openedWindow) {
              openedWindow.opener = null
            }

            return true
          }

          return false
        },
      },
    })

    plugins.push(ctrlClickHandler)

    return plugins
  },
})
